import React, { useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Svgs } from '../../../assets/svg';
import SelectionPopup from '../../../components/SelectionPopup';

interface InheritanceOption {
  id: 'inherit' | 'override';
  label: string;
  description: string;
}

interface PricebookInheritanceDropdownProps {
  parentTierName: string;
  isInherited: boolean;
  isCustom: boolean;
  onInherit: () => void;
  onOverride: () => void;
}

const InheritanceDropdown: React.FC<PricebookInheritanceDropdownProps> = ({
  parentTierName,
  isInherited,
  isCustom,
  onInherit,
  onOverride,
}) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const options: InheritanceOption[] = [
    {
      id: 'inherit',
      label: 'Inherit',
      description: `Inherit fee share settings from ${parentTierName.toLowerCase()}`,
    },
    {
      id: 'override',
      label: 'Override',
      description: 'Set custom fee share for this pricebook',
    },
  ];

  return (
    <SelectionPopup
      title={`Inherit from ${parentTierName.toLowerCase()} or override?`}
      visible={isPopupVisible}
      onClickOutside={() => setIsPopupVisible(false)}
      checkmarkIcon={<Svgs.IconCheckmarkSecondary />}
      items={options}
      initialSelectedId={isInherited ? 'inherit' : 'override'}
      renderItem={option => (
        <Box>
          <Typography variant='p16' color='secondary.dark' component='span' display='block'>
            {option.label}
          </Typography>
          <Typography variant='p12' color='secondary.main' component='span' display='block'>
            {option.description}
          </Typography>
        </Box>
      )}
      getItemKey={option => option.id}
      onItemClick={async (optionId: string) => {
        setIsPopupVisible(false);
        if (optionId === 'inherit') {
          onInherit();
        } else {
          onOverride();
        }
        return false;
      }}>
      <Chip
        className='selection-chip'
        label={
          <Box display='flex' alignItems='center' gap={0.5}>
            {isCustom ? 'Custom' : 'Inherited'}
            <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
          </Box>
        }
        variant='outlined'
        size='small'
        onClick={() => setIsPopupVisible(prev => !prev)}
      />
    </SelectionPopup>
  );
};

export default InheritanceDropdown;
